export default __webpack_public_path__ + "static/media/redvelvet.b0a8968a.png";